import { makeStyles } from 'tss-react/mui';

const useStylesCheckbox: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  checkbox: {
    padding: '10px !important',
  },
  checkboxHeader: {
    color: `${theme.palette.common.white} !important`,
    padding: '0 !important',
    '& svg': {
      fill: `${theme.palette.background.default} !important`,
      marginTop: '-1px !important',
    },
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },
  checkboxNoPadding: {
    padding: '0 !important',
  },
  checkboxOffset: {
    marginLeft: '10px !important',
  },
  checkboxLight: {
    color: `${theme.palette.common.white} !important`,
  },
}));

export default useStylesCheckbox;
